import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { CarouselModule } from 'primeng/carousel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppMenuComponent } from './app.menu.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { MenuService } from './app.menu.service';
import { ThemeService } from './core/services/theme.service';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { CookieModule } from 'ngx-cookie';
import { AuthInterceptor } from './security/services/auth.interceptor';
import { ErrorInterceptor } from './security/services/error-interceptor.interceptor';
import { ToastModule } from 'primeng/toast';
import { PagesCoreModule } from './modules/core-megaloto/pages/pages-core.module';
import { PagesGenerateSelectionModule } from './modules/core-megaloto/pages/pages-generate-selection-core/pages-generate-selection.module';
import { PagesReportCoreModule } from './modules/core-megaloto/pages/pages-report-core/pages-report-core.module';
import { PagesViewConfigCoreModule } from './modules/core-megaloto/pages/pages-view-config-core/pages-view-config-core.module';
import { PagesConfigPresorteoCoreModule } from './modules/core-megaloto/pages/pages-config-presorteo-core/pages-config-presorteo-core.module';
import { LibWebLayoutTemplatesModule } from 'projects/lib-web-layout-templates/src/public-api';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializerFn(themeService: ThemeService): any {
    return () => {
        return themeService.load();
    };
}

@NgModule({
    declarations: [
        AppComponent,
        AppMainComponent,
        AppMenuComponent,
        AppTopBarComponent,
        AppFooterComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        CarouselModule,
        PanelMenuModule,
        SharedModule,
        CookieModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        CoreModule,
        LibWebLayoutTemplatesModule,
        ToastModule,
        PagesCoreModule,
        PagesGenerateSelectionModule,
        PagesReportCoreModule,
        PagesViewConfigCoreModule,
        PagesConfigPresorteoCoreModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        MenuService,
        AppMainComponent,
        DatePipe,
        MessageService,
        ConfirmationService,
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [ThemeService],
            useFactory: initializerFn
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
